import { useTranslation } from 'react-i18next'
import { ComponentLayout } from '../../../components/layouts/ComponentLayout'
import styled from 'styled-components'
import { theme } from '../../../theme/theme'
import { useGetCertificationQuery } from '../../../api/ester-b2b-api/private/certification/certificationQueries'
import { CertificateLevel } from '@estercare/ester-shared'
import { CertificateLogoCard } from './CertificateCard'
import { ReportCard } from './ReportCard'
import { NextStepsCard } from './NextStepsCard'
import { Header } from '../../../components/Header'
import { Wave } from '../../../components/wave/Wave'
import { LoadingSpinner } from '../../../components/LoadingSpinner'
import { ErrorGuard } from '../../../components/ErrorGuard'

export const CertificationResults = () => {
  const { t } = useTranslation()
  const { data, isLoading, isError, error } = useGetCertificationQuery()

  if (isLoading) return <LoadingSpinner />
  if (isError || !data) return <ErrorGuard error={error} />

  const { level, reportUrl, actions } = data

  const developing = level === CertificateLevel.DEVELOPING
  const capitalizedLevel = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase()
  return (
    <>
      <Header
        backButtonLink="/admin/services"
        backgroundColor={theme.color.transparent}
        title={t('admin.certification.resultsTitle')}
        description={t('admin.certification.resultsDescription')}
        descriptionEmphasis={
          developing
            ? t('admin.certification.notAchievedCertification')
            : t('admin.certification.achievedCertification', { level: capitalizedLevel })
        }
        noPaddingBottom
        maxWidth={740}
      />
      <StyledWaveWrapper>
        <Wave color={theme.color.beigeDark} />
      </StyledWaveWrapper>

      <ComponentLayout paddingTop={0} backgroundColor={theme.color.beigeDark} paddingBottom={theme.spacing.xxlarge}>
        {level && level !== CertificateLevel.DEVELOPING && <CertificateLogoCard level={level} />}
        {reportUrl && <ReportCard reportUrl={reportUrl} />}
        {actions && <NextStepsCard actions={actions} />}
      </ComponentLayout>
    </>
  )
}

const StyledWaveWrapper = styled.div`
  margin-top: -30px;
`
